import React from "react";
import { AWS_URL } from "../config/constants";
import { useTranslation } from "react-i18next";

const AccountVerifyTick = ({ height, width, style }) => {
  const { t } = useTranslation();

  return (
    <img
      className="cancel-img-fit"
      height={height}
      width={width}
      style={style ? style : {}}
      src={`${AWS_URL}logo/verify.svg`}
      alt={t("creatorsettings.verified")}
      title={t("creatorsettings.verified")}
    />
  );
};

export default AccountVerifyTick;
